"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SponsorBox = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const StyledAvatar = (0, _mui.styled)(_mui.Avatar)(({
  theme
}) => ({
  width: '85px',
  height: '85px',
  marginBottom: theme.spacing(2),
  color: theme.palette.default.light,
  backgroundColor: theme.palette.grey[100],
  textDecoration: 'none'
}));
const InnerTextContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  marginLeft: theme.spacing(3)
}));
const StyledNameLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 4,
  maxHeight: 'calc(1.5em * 4)',
  marginBottom: theme.spacing(1),
  width: '100%'
}));
const SponsorBox = props => {
  const {
    customerReferral
  } = (0, _contexts.useConfiguration)();
  const {
    title,
    registrationId,
    displayOrder,
    invitationCode,
    refreshMetadata
  } = props;
  const {
    data: sponsorInfoData
  } = (0, _globalApiClientReact.useGetCustomerRegistrationInstructionSponsorInfo)(registrationId);
  const sponsorImage = (0, _hooks.useSponsorImageQuery)(sponsorInfoData?.customerId, sponsorInfoData?.profileImageDocumentId);
  const internationalPbs = customerReferral?.ReferralType === 'InternationalPbs';
  const defaultInternationalSponsor = sponsorInfoData?.consultantNumber === 1 && invitationCode;
  const sponsorName = internationalPbs && customerReferral.InternationalPbsCode ? customerReferral.InternationalPbsCode : defaultInternationalSponsor ? invitationCode : sponsorInfoData?.fullName;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  (0, _react.useEffect)(() => {
    refreshMetadata();
    // eslint-disable-next-line react-hooks/exhaustive-deps --- we need only mount
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    mb: 3,
    width: "100%",
    ...getTestIdProps('sponsorBox-sponsorForm'),
    style: {
      order: displayOrder
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "subtitle2",
      color: "textPrimary",
      marginBottom: 3,
      fontSize: 16,
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      display: "flex",
      alignItems: "center",
      children: [sponsorInfoData?.fullName ?? customerReferral?.InternationalPbsCode ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAvatar, {
        src: defaultInternationalSponsor ? undefined : sponsorImage,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.UserFilled, {
          sx: {
            fontSize: '32px'
          }
        })
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(InnerTextContainer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNameLabel, {
          variant: "body1",
          color: "textPrimary",
          align: "left",
          sx: {
            fontWeight: 'bold'
          },
          fontSize: 17,
          children: sponsorName
        })
      })]
    })]
  });
};
exports.SponsorBox = SponsorBox;
//# sourceMappingURL=SponsorBox.js.map